import React from "react";
import "./footer.css";
import Logo from "../../../../../assets/images/vct_technologies_logo.png";
import { Link } from "react-router-dom";
function Footer() {
  return (
    <div className="wrap-footer">
      <div className="container">
        <div className="cstm-border">
          <div className="row mb-3 mb-md-0">
            <div className="col-md-3 pb-3">
              <img src={Logo} />
            </div>
            <div className="col-md-5"></div>
            <div className="col-md-3">
              <Link className="cta-footer" to="/privacypolicy" target="_blank">
                Privacy Policy
              </Link>
              <Link className="cta-footer" to="/termsofuse" target="_blank">
                Terms of Use
              </Link>
            </div>
          </div>
        </div>
        <div className="row">
          <p className="copyright">
            Copyrights©️ {new Date().getFullYear()} VCT Technologies-All Rights
            Reserved
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
